

import moment from "moment";
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import 'react-slideshow-image/dist/styles.css';
import ReactToPrint from 'react-to-print';
import { sum_amount_total_card, sum_amount_total_cash } from "../../../functions/fun_sum";
import sum_amount from "../../../functions/sum_total_amount";
import view_apartment_type_ar from "../../../functions/view_apartment_type";
import { getallusers, getpaymentsyear, getpaymenttype, _endPoints } from "../../../Helper/links";
import API from "../../../Helper/server/API";
import empty from '../../../public/svg/empty.svg';
import { InvoiceContext } from './invoices/Invoice_Context';
import InvoicePaymentsYear from "./invoices/invoice_payments_year";
import { view_month_ar } from "../../../functions/fun_view";
function PaymentsYear() {
    const toast = useRef(null);
    const componentRef = useRef();
    const buttonRef = useRef();
    const [isShown, setIsShown] = useState(false);
    const items = Array.from({ length: 5 }, (v, i) => i);
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const [loading_users, set_loading_users] = useState(false);
    const [loading_apartment, set_loading_apartment] = useState(false);
    const [loading_report_year, set_loading_report_year] = useState(false);
    //____________________________________________________________
    const [apartments, setApartments] = useState([]);
    const [apartments_view, setApartments_view] = useState([]);
    const [users, set_users] = useState([]);
    const [users_view, set_users_view] = useState([]);
    const [payment_by_customer, set_psyment_by_customer] = useState(true);
    const [payments_year, setPayments_year] = useState([]);
    const [payment_types, setPaymentTypes] = useState([])
    const [totals_month, setTotalsMonth] = useState([])
    //____________________________________________________________
    const [year, setYear] = useState(new Date());
    const [PrintInvoicePayments_Year, setPrintInvoicePaymentsYear] = useState(false);
    //_______________________________________________________________________________________
    //                      Get Reservationes
    const GetApartment = async () => {
        set_loading_apartment(true);
        const response = await API.get(_endPoints.apartments.get_all)
        if (response?.success === 1) {
            setApartments(response.data);
            setApartments_view(response.data);
        }
        set_loading_apartment(false);
    }
    const [loading_get_payment_type, set_loading_get_payment_type] = useState(true)
    const [payment_types_option, set_payment_types_option] = useState([])
    const [payment_types_view, set_payment_types_view] = useState([])
    const GetPaymentType = async () => {
        set_loading_get_payment_type(true);
        const response = await API.get(`${getpaymenttype}`)
        if (response?.success === 1) {
            set_payment_types_option(response.data);
            set_payment_types_view(response.data);
        }
        set_loading_get_payment_type(false);
    }
    const GetUsers = async () => {
        set_loading_users(true);
        const response = await API.get(getallusers)
        if (response?.success === 1) {
            set_users(response.users);
        }
        set_loading_users(false);
    }

    const GetPaymentsYear = async () => {
        set_loading_report_year(true);
        var users = [];
        var apartments = [];
        var payment_types = [];
        // eslint-disable-next-line array-callback-return
        users_view.map(item => {
            if (item.ID_user) {
                users.push(item.ID_user);
            }
        })
        // eslint-disable-next-line array-callback-return
        apartments_view.map(item => {
            if (item.ID_apartment) {
                apartments.push(item.ID_apartment);
            }
        })
        payment_types_view.map(item => {
            if (item.id_payment_type) {
                payment_types.push(item.id_payment_type);
            }
        })
        var data = {
            year: moment(year).format("yyyy"),
            users: users,
            apartments: apartments,
            payment_types: payment_types,
            payment_by_customer: payment_by_customer
        };
        // const response = await API.post(getpaymentsyear,data)
        const response = await API.post(getpaymentsyear, data)
        if (response?.success === 1) {
            setPayments_year(response?.payments);
            setPaymentTypes(response.payment_types);
            setTotalsMonth(response.totals);
        }
        else if (response?.success === 0) {
            setPayments_year([]);
            toast?.current?.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response.msg
            });
        }
        set_loading_report_year(false);
    }
    const ApartmentsViewItemTemplate = (apt) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl", paddingRight: ".5rem" }} >
                <span>{view_apartment_type_ar(apt.type)} - {apt.number}</span>
            </div>
        );
    };
    const UsersViewItemTemplate = (user) => {
        return (
            <div className="flex align-items-center gap-1" style={{ fontFamily: "Cairo", direction: "rtl", paddingRight: ".5rem" }} >
                <span>{user.name}</span>
            </div>
        );
    };
    //____________________________________________________________
    // formatter بسيط
    const money = (v) =>
        `${Number(v || 0).toLocaleString("en-US")} د.ل`;

    const handel_Year = (e) => {
        setYear(e.target.value);
    };
    const View_Month = (data) => {
        return (
            <strong >
                {moment(data.month).format('yyyy-MM')}
                <br></br>
                {view_month_ar(data.month)}
            </strong>
        )
    }
    const View_Amount = (data) => {
        if (data.amount < 0) {
            return (
                <strong style={{ color: "red" }}>
                    {Intl.NumberFormat("en-US").format(data.amount)} د.ل
                </strong>
            )
        }
        else {
            return (
                <strong style={{ color: "green" }}>
                    {Intl.NumberFormat("en-US").format(data.amount)} د.ل
                </strong>
            )
        }
    }
    const View_total_card = (data) => {
        if (data.total_card < 0) {
            return (
                <strong style={{ color: "red" }}>
                    {Intl.NumberFormat("en-US").format(data.total_card)} د.ل
                </strong>
            )
        }
        else {
            return (
                <strong style={{ color: "green" }}>
                    {Intl.NumberFormat("en-US").format(data.total_card)} د.ل
                </strong>
            )
        }
    }
    const View_total_cash = (data) => {
        if (data.total_cash < 0) {
            return (
                <strong style={{ color: "red" }}>
                    {Intl.NumberFormat("en-US").format(data.total_cash)} د.ل
                </strong>
            )
        }
        else {
            return (
                <strong style={{ color: "green" }}>
                    {Intl.NumberFormat("en-US").format(data.total_cash)} د.ل
                </strong>
            )
        }
    }
    const payTypeBody = (pt) => (row) => {
        const v = row?.methods?.[String(pt.id_payment_type)] ?? 0;
        return (
            <span style={{ color: Number(v) < 0 ? "red" : "black" }}>
                {money(v)}
            </span>
        );
    };
    useEffect(() => {
        GetApartment();
        GetPaymentType();
        GetUsers();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const scrollStyle = {
        overflowY: "auto",
        scrollbarWidth: "thin", // للمتصفحات غير Chrome

    };
    const scrollBarCSS = `
    ::-webkit-scrollbar {
            display: block !important;
            width: 5px;
            height: 8px;
        }
    `;
    return (
        <div className="page-wrapper" dir="rtl" >
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />

                <div className="page-heading">
                    <h1 className="page-title"> مدفــوعات السنــوية </h1>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a href="index.html"><i className="la la-home font-20"></i></a>
                        </li>
                    </ol>
                </div>

                <div className="card p-3">
                    <div className="col-md-12" style={{ fontFamily: "Cairo" }}>
                        <div className="row">
                            <div className="col-md-2">
                                <label id="lday"> السنــة </label>
                                <Calendar value={year} className="col-md-12" view="year"
                                    showButtonBar
                                    onChange={(e) => handel_Year(e)}
                                    maxDate={new Date()}
                                    dateFormat="yy"
                                    style={{ padding: "0", fontFamily: "Cairo" }}
                                    locale="ar"
                                    panelStyle={{ width: "100%", fontSize: "15px", fontFamily: "Cairo" }}
                                />
                            </div>

                            <div className="col-md-2">
                                <label id="lday"> نـــوع الإقــامة </label>
                                <MultiSelect className="col-md-12"
                                    options={apartments}
                                    value={apartments_view}
                                    loading={loading_apartment}
                                    itemTemplate={ApartmentsViewItemTemplate}
                                    onChange={(e) => setApartments_view(e.target.value)}
                                    optionLabel="number"
                                    display="chip"
                                    placeholder="اختار مكان الاقامة"
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%", padding: "0", }}
                                />
                            </div>
                            <div className="col-md-3">
                                <label id="lday"> طــريقة الدفـع </label>
                                <MultiSelect className="col-md-12"
                                    options={payment_types_option}
                                    value={payment_types_view}
                                    onChange={(e) => set_payment_types_view(e.target.value)}
                                    optionLabel="name_payment_type"
                                    display="chip"
                                    placeholder="اختار طرق الدفع "
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%", padding: "0", }}
                                    loading={loading_get_payment_type}
                                />
                            </div>
                            <div className="col-md-1">
                                <label id="lday">دفع العملاء</label>
                                <Button icon={payment_by_customer ? "pi pi-check" : "pi pi-times"} outlined severity={payment_by_customer ? "success" : "danger"}
                                    onClick={(e) => set_psyment_by_customer(payment_by_customer ? false : true)} className="col-md-12"
                                    label={<span>{payment_by_customer ? "عــرض" : "بــدون"}</span>}
                                />
                            </div>
                            <div className="col-md-3">
                                <label id="lday">المستخــدمين</label>
                                <MultiSelect className="col-md-12"
                                    options={users}
                                    value={users_view}
                                    loading={loading_users}
                                    itemTemplate={UsersViewItemTemplate}
                                    onChange={(e) => set_users_view(e.target.value)}
                                    optionLabel="name"
                                    display="chip"
                                    placeholder="اختار المستخدمين"
                                    emptyMessage={<p style={{ fontFamily: "Cairo", textAlign: "center" }}>لا توجد خيارات متاحة</p>}
                                    maxSelectedLabels={3}
                                    style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }}
                                />
                            </div>
                            <div className="col-md-1" >
                                <Button
                                    dir='ltr'
                                    type="button"
                                    icon="pi pi-search"
                                    label="عرض"
                                    outlined
                                    onClick={GetPaymentsYear}
                                    loading={loading_report_year}
                                    disabled={loading_users || loading_apartment ? true : false}
                                    style={{ fontFamily: "Cairo", marginTop: "30PX", display: "inline" }}
                                />
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <style>{scrollBarCSS}</style>
                    {
                        loading_report_year ?
                            <DataTable value={items} className="p-datatable-striped" tableStyle={{ minWidth: '50rem' }} style={{ fontFamily: "Cairo", direction: "rtl" }}>
                                <Column field="month" header="الشهر" sortable style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>
                                {/* <Column field="count_pay_day" header="عدد الدفعات"  style={{ width: '1%',textAlign:"right" }}></Column> */}
                                <Column field="total_card" header="الدفع بالبطاقة" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="total_cash" header="الدفع النقدي" style={{ width: '1%', textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="amount" header="المبلغ" style={{ width: '1%', textAlign: "right", color: "green" }} body={<Skeleton />}></Column>
                            </DataTable>
                            :
                            <>
                                <DataTable value={payments_year} loading={loading_report_year}
                                    selectionMode="multiple"
                                    metaKeySelection={false} dragSelection
                                    stripedRows showGridlines
                                    scrollable scrollHeight="700px"
                                    emptyMessage={<center><img src={empty} alt="empty" width={"10%"} className='m-4'></img><h3>لايــوجد مدفــوعات</h3></center>}
                                    tableStyle={scrollStyle}
                                    style={{ fontFamily: "Cairo", direction: "rtl" }}
                                >
                                    <Column field="month" header="الشهر" body={View_Month} sortable style={{ width: '1%', textAlign: "right" }}
                                        footer={<p style={{ fontSize: "18px", fontWeight: "bold" }}>الإجمــالي</p>}
                                    ></Column>
                                    {/* <Column field="count_pay_day" header="عدد الدفعات"  style={{ width: '1%',textAlign:"right" }}></Column> */}
                                    {/* ✅ أعمدة طرق الدفع ديناميكيًا */}
                                    {payment_types?.map((pt) => (
                                        <Column
                                            key={pt.id_payment_type}
                                            header={pt.name_payment_type}
                                            body={payTypeBody(pt)}
                                            style={{ width: "1%", textAlign: "right" }}
                                            footer={<p style={{ fontSize: "18px", fontWeight: "bold" }}>{money(totals_month?.methods?.[String(pt.id_payment_type)] ?? 0)}</p>}
                                        />
                                    ))}
                                    <Column
                                        field="amount"
                                        header="إجمـــالي المبلـــغ"
                                        body={View_Amount}
                                        style={{ width: "1%", textAlign: "right" }}
                                        footer={<p style={{ fontSize: "18px", fontWeight: "bold" }}>{money(totals_month?.amount ?? 0)}</p>}
                                    />

                                </DataTable>
                                <div className="col-md-12" dir="ltr">
                                    <Button dir='ltr' type="button" label=" عــرض " icon='fa fa-file' outlined
                                        onClick={e => setPrintInvoicePaymentsYear(true)}
                                    />
                                </div>
                            </>
                    }
                </div>
                {
                    PrintInvoicePayments_Year ?
                        (
                            <>
                                <Dialog dir="rtl" header="مدفوعات السنوية" visible={PrintInvoicePayments_Year} maximizable style={{ width: '50vw', fontFamily: "Cairo" }}
                                    onHide={() => setPrintInvoicePaymentsYear(false)} maximized={window.innerWidth <= 1230 ? true : false}
                                    footer={
                                        <div className="text-center">
                                            <ReactToPrint
                                                trigger={
                                                    () => <Button dir='ltr' type="button" label=" طبــاعة " icon='fa fa-print' outlined
                                                        ref={buttonRef} onClick={(e) => setIsShown(current => !current)}
                                                    />
                                                }
                                                content={() => componentRef.current}
                                            />
                                        </div>
                                    }
                                >
                                    <InvoiceContext.Provider value={{
                                        payments_year: payments_year,
                                        payment_types: payment_types,
                                        totals_month: totals_month,
                                    }}>
                                        {PrintInvoicePayments_Year && <div ref={componentRef}>   <InvoicePaymentsYear></InvoicePaymentsYear></div>}
                                    </InvoiceContext.Provider>

                                </Dialog>
                            </>
                        )
                        :
                        (null)
                }
            </div>
        </div>
    )
}

export default PaymentsYear


